import React, { useState,useEffect } from 'react';
import EmployeeBar from '../../Components/EmployeeBar/EmployeeBar';
import MainHeader from '../../Components/MainHeader/MainHeader';
import MapFilter from '../../Components/MapFilter/MapFilter';
import SideBar from '../../Components/SideBar/SideBar';
import HeatMap from '../../Components/HeatMap/HeatMap';
import LoaderBar from '../../Components/LoaderBar/LoaderBar';
import './LandingPage.css';
import MapView from '../../Components/MapView/MapView';
import { AppContext } from '../../Context';
import useAccess from '../LoginPage/useAccess';
import ErrorPage from '../ErrorPage/ErrorPage';
import jwtDecode from 'jwt-decode';
export default function LandingPage(props) {
 // set intial state
 const {getUserInfo,} = useAccess();
 const [ loader, setLoader ] = useState({});
 const [dealersData,setDealersData]=useState('employee');
 const [selectedOption,setSelectedOption] = useState({'zo' : '','ro' : '','dealer' : ''});
 const [options,setOptions] = useState({'zo' : [],'ro' : [],'dealer' : []});
 const [Dealerresult,setDealerresult] = useState([]);  
 const [stateData,setStateData] = useState({'selected' : {'State':'','District':'','Sub_District':'','Village':''},'mapObject' : {},'optionSelection' : {'level':'dealer','option':'ALL'}});
 const [dealerPoi,setDealerPoi]=useState(false);
//  const [tokenValid,setTokenValid]=useState(true);
 const [tokenValid, setIsValidToken] = useState(true);
//  const [stateData,setStateData] = useState({'selected' : {'State':'','District':'','Sub_District':'','Village':''},'mapObject' : {},'optionSelection' : {'level':getUserInfo()['level'],'option':'ALL'}});
 const [mapData,setMapData] = useState({});

 useEffect(() => {
    const token = localStorage.getItem('token'); // Retrieve token from local storage

    const decodedToken = jwtDecode(token);
    console.log("Decoded : ",decodedToken);

}, []);
useEffect(() => {
  // Function to check token validity
  const checkTokenValidity = () => {
    const token = localStorage.getItem('token'); // Retrieve token from local storage

    try {
      const decodedToken = jwtDecode(token); // Decode token using jwt-decode

      const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds

      // Compare current time with token's expiration time
      if (decodedToken.exp && decodedToken.exp > currentTime) {
        setIsValidToken(true); // Token is valid
      } else {
        setIsValidToken(false); // Token has expired
      }
    } catch (error) {
      setIsValidToken(false); // Token is not valid
    }
  };

  checkTokenValidity(); // Initial check when the component mounts

  // Setup interval to check token validity every 5 seconds
  const intervalId = setInterval(() => {
    checkTokenValidity();
  }, 5000);

  // Clean up the interval when the component unmounts
  return () => {
    clearInterval(intervalId);
  };
}, []);


    return(
        //<div className='container'>
        <section
        style={{
          backgroundImage: " url(background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "100vh",
          overflow:'hidden',
        }}
        >
          {tokenValid && <div>
          <AppContext.Provider value={{  stateData , setStateData , mapData , setMapData ,loader, setLoader,dealersData,setDealersData,Dealerresult,setDealerresult,dealerPoi,setDealerPoi,selectedOption,setSelectedOption,options,setOptions}}>
            <MainHeader nav={props.nav} removeAccess={props.removeAccess} profileVisiblilty={true}/>
            <EmployeeBar/>
            <MapFilter/>
            <SideBar/>
            <MapView/>
            <HeatMap/>
            <LoaderBar/>
            </AppContext.Provider>
        </div>}
        {!tokenValid && <div>
          <ErrorPage message='Token Expired'/>
        </div>}
        </section>
    );
}